export interface EShapeActionExtensionItem {
	type: number;
	label: string;
}
